var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      directives: [
        { name: "show", rawName: "v-show", value: true, expression: "true" }
      ],
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c(
        "div",
        { attrs: { align: "center" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-form",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "div",
                            { attrs: { align: "left" } },
                            [
                              _c("v-flex", [
                                _c(
                                  "h2",
                                  {
                                    staticClass: "h2_title",
                                    staticStyle: {
                                      "margin-top": "12px !important"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  General\n                "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          ),
                          _c("v-divider"),
                          _c("br"),
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "numero",
                                      label: _vm.formFields.numero.label,
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.formFields.numero.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.numero,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.numero.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "movimiento",
                                      label: _vm.formFields.usuario.label,
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.formFields.usuario.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.usuario,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.usuario.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "movimiento",
                                      label: _vm.formFields.estado.label,
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.formFields.estado.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.estado,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.estado.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "movimiento",
                                      label: _vm.formFields.cantidad.label,
                                      disabled: true
                                    },
                                    model: {
                                      value: _vm.formFields.cantidad.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.cantidad,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.cantidad.value"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs4: "", sm4: "", md4: "" } },
                                [
                                  _c("v-autocomplete", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      name: "movimiento",
                                      label: _vm.formFields.motivo.label,
                                      items: _vm.findFilterList({
                                        key: "motibaja"
                                      }),
                                      "item-text": "motiname",
                                      "item-value": "motiid",
                                      rules: [_vm.rules.required]
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$emit(
                                          "motivo",
                                          _vm.formFields.motivo.value
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.formFields.motivo.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.motivo,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.motivo.value"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }